module.exports = __webpack_public_path__ + "static/media/status-atrasado.717798a7.svg";